import { render, staticRenderFns } from "./dorm01.vue?vue&type=template&id=a0cea72e&scoped=true"
import script from "./dorm01.vue?vue&type=script&lang=js"
export * from "./dorm01.vue?vue&type=script&lang=js"
import style0 from "./dorm01.vue?vue&type=style&index=0&id=a0cea72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cea72e",
  null
  
)

export default component.exports